import React, { useEffect, useRef } from "react";


import scrollToDomElement from "@Utilities/Scrolling";


import {
    UserSubmitRequestDataInterface
} from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest";


import {
    Row, Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";


import {
    UserDashboardSubmitRequestStep1Component,
    UserDashboardSubmitRequestStep2Component,
    UserDashboardSubmitRequestStep3Component,
    UserDashboardSubmitRequestStep4Component,
    UserDashboardSubmitRequestStep5Component
} from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/Steps";


import IconRadioUncheckedMdGrey from "./@Icons/icon-radio_unchecked-md-grey.svg";
import IconRadioCheckedMdOrange from "./@Icons/icon-radio_checked-md-orange.svg";
import IconRadioCheckedMdGreen from "./@Icons/icon-checked_round-md-green.svg";


import "./index.scss";
import {FileWithPath} from "react-dropzone";


interface UserDashboardSubmitRequestStepsComponentProps {
    userSubmitRequestStepNumber: number;
    userSubmitRequestStepSetter: (step: number) => void;
    userSubmitRequestData: UserSubmitRequestDataInterface;
    userSubmitRequestDataSetter: (userSubmitRequestData: UserSubmitRequestDataInterface) => void;
    userSubmitRequestAttachedFilesList: File[];
    userSubmitRequestAttachedFilesListSetter: (filesList: File[]) => void;
}


export const UserDashboardSubmitRequestStepsComponent:React.FC<UserDashboardSubmitRequestStepsComponentProps> = ({
    userSubmitRequestStepNumber, userSubmitRequestStepSetter,
    userSubmitRequestData, userSubmitRequestDataSetter,
    userSubmitRequestAttachedFilesList, userSubmitRequestAttachedFilesListSetter
}) => {


    const stepsListStepContentRef = useRef(null);

    useEffect(() => {
        if (stepsListStepContentRef?.current) {
            scrollToDomElement(stepsListStepContentRef.current, -50);
        }
    }, [userSubmitRequestStepNumber]);


    return (
        <Col className={`user-dashboard-submit-request-steps`} ref={stepsListStepContentRef}>
            <Row className={`user-dashboard-submit-request-steps__steps-container`}>

                <Col xs={12}  className={`user-dashboard-submit-request-steps__steps-list-header`}>
                    <span>Request to recover your funds.</span>
                </Col>

                <Col xs={12} xl={{ span: 10, offset: 1 }} className={`user-dashboard-submit-request-steps__steps-list-progress`}>
                    <Row className={`user-dashboard-submit-request-steps__steps-list-progress__progress-content`}>
                        <Col xs={'auto'} className={`user-dashboard-submit-request-steps__steps-list-progress__progress-element`}>
                            <SvgIconComponent iconSource={userSubmitRequestStepNumber === 1 ? IconRadioCheckedMdOrange : (userSubmitRequestStepNumber > 1 ? IconRadioCheckedMdGreen : IconRadioUncheckedMdGrey)} />
                            <span className={'user-dashboard-submit-request-steps__steps-list-progress__progress-element__element-text'}>Type of refund request</span>
                        </Col>
                        <Col xs={'auto'} className={`user-dashboard-submit-request-steps__steps-list-progress__progress-separator`}>
                            <span></span>
                        </Col>
                        <Col xs={'auto'} className={`user-dashboard-submit-request-steps__steps-list-progress__progress-element`}>
                            <SvgIconComponent iconSource={userSubmitRequestStepNumber === 2 ? IconRadioCheckedMdOrange : (userSubmitRequestStepNumber > 2 ? IconRadioCheckedMdGreen : IconRadioUncheckedMdGrey)}/>
                            <span className={'user-dashboard-submit-request-steps__steps-list-progress__progress-element__element-text'}>Documents</span>
                        </Col>
                        <Col xs={'auto'}
                             className={`user-dashboard-submit-request-steps__steps-list-progress__progress-separator`}>
                        <span></span>
                        </Col>
                        <Col xs={'auto'}
                             className={`user-dashboard-submit-request-steps__steps-list-progress__progress-element`}>
                            <SvgIconComponent
                                iconSource={userSubmitRequestStepNumber === 3 ? IconRadioCheckedMdOrange : (userSubmitRequestStepNumber > 3 ? IconRadioCheckedMdGreen : IconRadioUncheckedMdGrey)}/>
                            <span
                                className={'user-dashboard-submit-request-steps__steps-list-progress__progress-element__element-text'}>Personal data</span>
                        </Col>
                        <Col xs={'auto'} className={`user-dashboard-submit-request-steps__steps-list-progress__progress-separator`}>
                            <span></span>
                        </Col>
                        <Col xs={'auto'}
                             className={`user-dashboard-submit-request-steps__steps-list-progress__progress-element`}>
                            <SvgIconComponent iconSource={userSubmitRequestStepNumber === 4 ? IconRadioCheckedMdOrange : (userSubmitRequestStepNumber > 4 ? IconRadioCheckedMdGreen : IconRadioUncheckedMdGrey)}/>
                            <span className={'user-dashboard-submit-request-steps__steps-list-progress__progress-element__element-text'}>Sign a form</span>
                        </Col>
                        <Col xs={'auto'} className={`user-dashboard-submit-request-steps__steps-list-progress__progress-separator`}>
                            <span></span>
                        </Col>
                        <Col xs={'auto'}
                             className={`user-dashboard-submit-request-steps__steps-list-progress__progress-element`}>
                            <SvgIconComponent
                                iconSource={userSubmitRequestStepNumber === 5 ? IconRadioCheckedMdOrange : (userSubmitRequestStepNumber > 5 ? IconRadioCheckedMdGreen : IconRadioUncheckedMdGrey)}/>
                            <span
                                className={'user-dashboard-submit-request-steps__steps-list-progress__progress-element__element-text'}>Submit the request</span>
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} lg={{span: 10, offset: 1}} className={`user-dashboard-submit-request-steps__steps-list-content`}>
                    <Row className={`user-dashboard-submit-request-steps__steps-list-content__list-content`}>

                        {userSubmitRequestStepNumber === 1 &&
                        <UserDashboardSubmitRequestStep1Component
                            userSubmitRequestStepSetter={userSubmitRequestStepSetter}
                            userSubmitRequestData={userSubmitRequestData}
                            userSubmitRequestDataSetter={userSubmitRequestDataSetter}
                        />
                        }

                        {userSubmitRequestStepNumber === 2 &&
		                    <UserDashboardSubmitRequestStep2Component
			                    userSubmitRequestStepSetter={userSubmitRequestStepSetter}
			                    userSubmitRequestData={userSubmitRequestData}
			                    userSubmitRequestDataSetter={userSubmitRequestDataSetter}
		                        userSubmitRequestAttachedFilesList={userSubmitRequestAttachedFilesList}
                                userSubmitRequestAttachedFilesListSetter={userSubmitRequestAttachedFilesListSetter}
                            />
                        }

                        {userSubmitRequestStepNumber === 3 &&
		                    <UserDashboardSubmitRequestStep3Component
			                    userSubmitRequestStepSetter={userSubmitRequestStepSetter}
			                    userSubmitRequestData={userSubmitRequestData}
			                    userSubmitRequestDataSetter={userSubmitRequestDataSetter}
		                    />
                        }

                        {userSubmitRequestStepNumber === 4 &&
		                    <UserDashboardSubmitRequestStep4Component
			                    userSubmitRequestStepSetter={userSubmitRequestStepSetter}
			                    userSubmitRequestData={userSubmitRequestData}
			                    userSubmitRequestDataSetter={userSubmitRequestDataSetter}
			                />
                        }

                        {userSubmitRequestStepNumber === 5 &&
		                    <UserDashboardSubmitRequestStep5Component
			                    userSubmitRequestStepSetter={userSubmitRequestStepSetter}
			                    userSubmitRequestData={userSubmitRequestData}
			                    userSubmitRequestAttachedFilesList={userSubmitRequestAttachedFilesList}
		                    />
                        }

                        {/*<Col xs={12} className={'user-dashboard-submit-request-step'}>*/}
                        {/*    <Row className={'user-dashboard-submit-request-step__step-content'}>*/}
                        {/*        <Col xs={12} className={'user-dashboard-submit-request-step__step-header'}>*/}
                        {/*            Example*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>*/}
                        {/*            <Row className={'user-dashboard-submit-request-step__step-section__section-content'}>*/}
                        {/*                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>*/}
                        {/*                    <span>Example</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-description'}>*/}
                        {/*                    <span>Example Description</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>*/}
                        {/*                    <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>*/}

                        {/*                    </Row>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>*/}
                        {/*            <Row className={'user-dashboard-submit-request-step__step-section__section-content'}>*/}
                        {/*                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>*/}
                        {/*                    <span>Example</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-description'}>*/}
                        {/*                    <span>Example Description</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>*/}
                        {/*                    <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>*/}

                        {/*                    </Row>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*        </Col>*/}
                        {/*        <Col className={'user-dashboard-submit-request-step__step-buttons'}>*/}
                        {/*            <Row className={'user-dashboard-submit-request-step__step-buttons__buttons-content'}>*/}
                        {/*                <ButtonComponent*/}
                        {/*                    size={'l'} type={'flat'}*/}
                        {/*                    text={'Back'} iconLeft={IconArrowLeftSmBrown}*/}
                        {/*                    callback={() => userSubmitRequestStepSetter(0)}*/}
                        {/*                />*/}
                        {/*                <ButtonComponent*/}
                        {/*                    size={'l'}*/}
                        {/*                    text={'Next Step'} iconRight={IconArrowRightSmBrown}*/}
                        {/*                    callback={() => userSubmitRequestStepSetter(2)}*/}
                        {/*                />*/}
                        {/*            </Row>*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*</Col>*/}

                    </Row>
                </Col>



            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestStepsComponent;
